
import {evaluateThreshold,getFieldThreshold} from './utils';
import {getTableColor, formatCellValue} from './utils';
import styled from 'styled-components';

export const StyledGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 8px;
    overflow-y: auto;
`;

export const StyledGridCard = styled.div`
  background: ${({ theme }) => theme.darkMode ? '#1a1a1a' : '#f9fafb'};
  border-radius: 6px;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.darkMode ? 'rgb(51, 51, 51)' : '#e5e7eb'};
  transition: all 0.2s;
  :hover {
    border-color: ${({ theme }) => theme.darkMode ? '#9ca3af' : '#9ca3af'};
    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);
  }
`;

export const StyledGridCardHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.darkMode ? '#9ca3af' : 'rgb(51, 51, 51)'};
  border-bottom: 1px solid ${({ theme }) => theme.darkMode ? 'rgb(51, 51, 51)' : '#e5e7eb'};
`;

export const StyledGridCardLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  text-transform: capitalize;
`;

export const StyledGridCardValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.darkMode ? '#9ca3af' : 'rgb(51, 51, 51)'};
`;


export const GridView = ({data, widget }:any) =>{

const valueKey = Array.isArray(widget.dataKey) ? [...widget.dataKey] : [widget.valueKey];

// Use gridColumns if specified, otherwise use auto-fill
const gridTemplateColumns = widget.gridColumns 
  ? `repeat(${widget.gridColumns}, minmax(200px, 1fr))` 
  : 'repeat(auto-fill, minmax(200px, 1fr))';

return (
      <StyledGrid style={{height: widget.height || '200px', gridTemplateColumns }}>
        {data.map((item:any, idx:any) => {

          const threshold = getFieldThreshold(item.name || valueKey[0], widget.fields);
          const thresholdResult = evaluateThreshold(item[valueKey[0]] , threshold?.threshold);
          return (
          <StyledGridCard key={idx} >
            <StyledGridCardHeader>
              {(() => {
                  // 1. Format the value first
                  const rawValue = item[widget.xKey];
                  // 2. Check length and truncate if needed
                  return rawValue.length > 40 
                    ? `${rawValue.slice(0, 40)}...` 
                    : rawValue;
                })()}
            </StyledGridCardHeader>
            <div className="grid-card-body">
              {Array.isArray(widget.dataKey) ? (
                widget.dataKey.map((key:any) => (
                  <div key={key} className="grid-card-metric" >
                    <StyledGridCardLabel>
                      {(() => {
                              // 1. Format the value first
                              const rawValue = key;
                              // 2. Check length and truncate if needed
                              return rawValue.length > 24 
                                ? `${rawValue.slice(0, 24)}...` 
                                : rawValue;
                            })()}
                    </StyledGridCardLabel>
                    <StyledGridCardValue style={{ color: getTableColor(key,item,widget.fields)}}>
                      {formatCellValue(item[key], widget.isPricing === true)}
                    </StyledGridCardValue>
                  </div>
                ))
              ) : (
                <div className="grid-card-metric">
                  <span className="grid-card-value large" style={{color: thresholdResult?.color}}>
                      {formatCellValue(item[widget.valueKey], widget.isPricing === true)}
                  </span>
                </div>
              )}
            </div>
          </StyledGridCard>
        )})}
      </StyledGrid>
    );
}
